
import Vue from 'vue';
import axios from 'axios';
import TextInput from '@shared/components/TextInput.vue';
import TextArea from '@shared/components/TextArea.vue';
import SelectInput from '@shared/components/SelectInput.vue';

export default Vue.extend({
  name: 'contact-us',
  components: {
    TextInput,
    TextArea,
    SelectInput,
  },
  data() {
    return {
      inquiry: process.env.VUE_APP_INQUIRY as string,
      phone: false,
      email: false,
      isFormSentSuccess: false,
      errors: [''],
      form: {
        name: '',
        email: '',
        phone: '',
        description: '',
        inquiry: '',
        company: '',
      },
    };
  },
  computed: {
    isDevMode(): boolean {
      return process.env.VUE_APP_ENV === 'test';
    },
  },
  methods: {
    submitForm(e: Event) {
      if (this.checkForm(e)) {
        const http = axios.create({
          baseURL: process.env.VUE_APP_BACKEND_URL,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const a = {} as any;
        a[this.inquiry] = this.form.inquiry;
        a.subject = this.form.inquiry;
        a.external = 1;
        a['recordType'] = process.env.VUE_APP_RECORDTYPE as string;

        const postData = Object.assign(a, this.form); // Merge form data with salesforce ids

        let pd = '';
        Object.keys(postData).forEach((key) => {
          if (pd.length > 1) {
            pd += '&';
          }
          pd += `${key}=${encodeURI(postData[key])}`;
        });

        // @ts-ignore
        this.$gtm.trackEvent({
          event: 'submit_contact_form',
          category: 'Kontakt',
          action: 'Fullført kontaktskjema kundeservice',
          label: this.form.inquiry,
        });

        http
          .post('', pd)
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .then()
          .catch((err) => console.log('err', err));

        this.isFormSentSuccess = true;
      }
    },
    checkForm: function (e: Event) {
      this.errors = [];

      if (!this.form.inquiry) {
        this.errors.push('Hva gjelder henvendelsen?');
      }

      if (!this.form.name) {
        this.errors.push('Mangler navn.');
      }

      if (this.form.phone == '') {
        this.errors.push('Mangler telefon.');
      }
      if (this.form.email == '') {
        this.errors.push('Mangler epost.');
      }
      if (this.form.email == undefined) {
        this.errors.push('Mangler epost.');
      }
      if (this.form.email && this.validateEmail()) {
        this.errors.push('Ikke gyldig epostadresse');
      }
      if (!this.form.description) {
        this.errors.push('Mangler melding.');
      }

      if (!this.errors.length) {
        return true;
      }
      e.preventDefault();
    },
    setInquiry(e: any) {
      this.form.inquiry = e.target.value;
    },
    validateEmail() {
      return (
        this.form.email &&
        !new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$').test(
          this.form.email
        )
      );
    },
  },
});
